import { render } from "./SearchResultView.vue?vue&type=template&id=3e8c2916&scoped=true"
import script from "./SearchResultView.vue?vue&type=script&lang=js"
export * from "./SearchResultView.vue?vue&type=script&lang=js"

import "./SearchResultView.vue?vue&type=style&index=0&id=3e8c2916&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8c2916"]])

export default __exports__